module.exports = __webpack_public_path__ + "assets/cbb82e78104501d40d75cf25363959f1.mp3";